// ─── Firebase Collection Names ────────────────────────────────────────────────
export const COLLECTIONS = {
  ORDERS: "orders",
  ASSIGNMENTS: "assignments",
  PAYMENTS: "payments",
};

// ─── Route Paths ──────────────────────────────────────────────────────────────
export const DETAIL_ROUTES = {
  ORDERS: "/orders",
  ASSIGNMENTS: "/assignments",
  PAYMENTS: "/payments",
};

// ─── Order Status Colors ──────────────────────────────────────────────────────
// Each status key maps to an Ant Design tag color or a custom hex.
// Add new statuses here as they emerge in production.
export const ORDER_STATUS_COLORS = {
  // Common garment order statuses — extend as needed
  pending: "#f0a500",
  confirmed: "#1677ff",
  processing: "#7c3aed",
  "in-production": "#0891b2",
  "quality-check": "#059669",
  "ready-to-ship": "#16a34a",
  shipped: "#2563eb",
  delivered: "#15803d",
  cancelled: "#dc2626",
  "on-hold": "#9ca3af",
  returned: "#b45309",
  refunded: "#db2777",
  // Fallback for any unrecognised status
  default: "#6b7280",
};

// ─── Assignment Status Colors ─────────────────────────────────────────────────
export const ASSIGNMENT_STATUS_COLORS = {
  assigned: "#1677ff",
  accepted: "#7c3aed",
  "in-progress": "#0891b2",
  completed: "#15803d",
  rejected: "#dc2626",
  "on-hold": "#9ca3af",
  cancelled: "#b45309",
  default: "#6b7280",
};

// ─── Payment Status Labels ────────────────────────────────────────────────────
export const PAYMENT_STATUS = {
  FULLY_PAID: "fullyPaid",
  PARTIALLY_PAID: "partiallyPaid",
  PENDING: "pending",
};

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS.FULLY_PAID]: "Fully Paid",
  [PAYMENT_STATUS.PARTIALLY_PAID]: "Partially Paid",
  [PAYMENT_STATUS.PENDING]: "Pending Payment",
};

export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.FULLY_PAID]: { bg: "#f0fdf4", border: "#86efac", text: "#15803d", dot: "#22c55e" },
  [PAYMENT_STATUS.PARTIALLY_PAID]: { bg: "#fffbeb", border: "#fcd34d", text: "#b45309", dot: "#f59e0b" },
  [PAYMENT_STATUS.PENDING]: { bg: "#fff1f2", border: "#fda4af", text: "#be123c", dot: "#f43f5e" },
};
